module.exports = __webpack_public_path__ + "fashion.2714038d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/fashion.png
// module id = 1741
// module chunks = 0